// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PasswordRecoveryChangeResponse extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_RECOVERY_CHANGE_RESPONSE, fieldSet);
    }
    getStatus() {
        return this.getFieldValue(FieldsFactory.FIELD_CHANGE_PWD_STATUS);
    }
    getMinLength() {
        return this.getFieldValue(FieldsFactory.FIELD_MIN_PASSWORD_LENGTH);
    }
}
